<template>
  <div>
    <div class="jumbotron">
      <div class="mask"></div>
      <b-row class="mx-auto" style="max-width: 1460px">
        <HomeText></HomeText>
        <b-col sm="1"> </b-col>
        <b-col sm="6">
          <b-row class="">
            <HomeOrg></HomeOrg>
            <HomeTra></HomeTra>
          </b-row>
          <div class="text-right mt-5">
            <router-link to="/compliance" class="text-white">compliance</router-link>
          </div>
        </b-col>
      </b-row>
    </div>
    <HomeSteps></HomeSteps>
  </div>
</template>
<script>
import util from "@/mixing/util";
import HomeOrg from "@/components/HomeOrg";
import HomeTra from "@/components/HomeTra";
import HomeText from "@/components/HomeText";
import HomeSteps from "@/components/HomeSteps";

export default {
  name: "Home",
  components: { HomeOrg, HomeTra, HomeText, HomeSteps },
  mixins: [util],
  created(){
    if(localStorage.dest_lang)
      localStorage.removeItem('dest_lang');
  }
};
</script>
<style scoped>
.jumbotron {
  background-image: url("/img/bg-home.png");
}
</style>
